import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";

@Injectable({
  providedIn: "root",
})
export class UserAPIService implements IApiBase{


  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
    this.estatus = new EstatusJSON();
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }

  delete(UserId): any{
    return this.http.get<EstatusJSON>(this.configUrl + "/api/AuthManagement/DeleteUser?UserId="+UserId);
  }

  getUpdateUser(id): Observable<EstatusJSON>{
    return this.http.get<EstatusJSON>(this.configUrl + "/api/AuthManagement/UpdateUser?Id="+id);
  }

  //cambió de InsertUser a registerUser
  getInsertUser(): Observable<EstatusJSON>{
    return this.http.get<EstatusJSON>(this.configUrl + "/api/AuthManagement/registerUserUI", {});
  }

  //cambió de InsertUser a registerUser
  postInsertUser(formData: any): Observable<EstatusJSON> {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/AuthManagement/registerUserUI", formData);
  }

  postUpdateUser(formData: any): Observable<EstatusJSON> {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/AuthManagement/UpdateUserUI", formData);
  }

  //paginacion
  getFilterValues(request : FilterRequest[]) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/UserCatalog/GetFilterValues", request);
  }

  getPage(pageRequest: CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/UserCatalog/GetUsersPage", pageRequest);
  }

  getCount(pageRequest: CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/UserCatalog/GetUsersCount", pageRequest);
  }
  
}
